import React from 'react'

// import Page from '../../page';
import { Image } from '../utils/lazyImage'
//
import HeaderSpacer from '../global/header-spacer'
import Navigation from '../navigation'
import { Grid, GridItem } from '../grid'

import PortfolioItem from './item'

import Styles from '../../styles/components/portfolioSingle.module.scss'

import globalState from '../../helpers/globalState'

function prepareImageSizes(prepare, item) {
  const sizes = { ...prepare[item.tall ? `res_${item.wide}` : 'sizes'] }

  return sizes
}

class PortfolioSingleComponent extends React.PureComponent {
  constructor(props) {
    super(props)

    // this.setSizeState = this.setSizeState.bind(this)
    this.state = {
      twocolumns: false,
    }
  }

  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
    }
  }

  // renderItem__(item, index) {
  //   let type = null,
  //     elem = null

  //   if (item.__typename === 'WordPressAcf_text' && item.text) {
  //     type = 'text'
  //     elem = (
  //       <div
  //         className="styled-content"
  //         dangerouslySetInnerHTML={{
  //           __html: item.text,
  //         }}
  //       />
  //     )
  //   } else if (item.__typename === 'WordPressAcf_image' && item.obrazek) {
  //     type = 'image'
  //     elem = (
  //       <Image
  //         sizes={prepareImageSizes(
  //           item.obrazek.localFile.childImageSharp,
  //           item
  //         )}
  //       />
  //     )
  //   }

  //   if (type && elem) {
  //     return (
  //       <div
  //         key={`item_${index}`}
  //         className={[Styles[`wide_${item.wide}`], Styles[`item_${type}`]].join(
  //           ' '
  //         )}
  //       >
  //         {elem}
  //       </div>
  //     )
  //   }
  //   return null
  // }

  renderItem2(item, index) {
    let elem = null

    if (item.type === 'image' && item.croppedImage) {
      elem = <Image sizes={item.croppedImage} />
    } else if (item.type === 'text' && item.text) {
      elem = (
        <div
          className="styled-content"
          dangerouslySetInnerHTML={{
            __html: item.text,
          }}
        />
      )
    }

    // const classNames = [
    //   Styles[`portfolioItem--${item.size}`],
    //   Styles[`portfolioItem--${item.type}`],
    // ]

    if (elem) {
      return (
        <GridItem
          key={`item_${index}`}
          size={item.size}
          className={Styles[`portfolioItem--${item.type}`]}
        >
          {elem}
        </GridItem>
        // <div key={`item_${index}`} className={classNames.join(' ')}>
        //   {elem}
        // </div>
      )
    }
    //
    return null
  }

  // componentDidMount() {
  //   const desktopViewport = window.matchMedia('(min-width: 1500px)')
  //   desktopViewport.addListener(this.setSizeState)
  //   this.setSizeState(desktopViewport)
  // }

  // setSizeState(mq) {
  //   this.setState(state => ({
  //     ...state,
  //     twocolumns: mq.matches,
  //   }))
  // }

  // renderItems() {
  //   const { twocolumns } = this.state
  //   const items = this.props.data.portfolio.acf.content

  //   let rows = 0
  //   if (twocolumns) {
  //     return '2 kolumns'
  //   } else {
  //     return items.map(this.renderItem2)
  //   }
  // }

  render() {
    // if (
    //   this.props.data.portfolio.featured_media &&
    //   !this.props.data.portfolio.featured_media.localFile
    // ) {
    //   console.log('')
    //   console.log('')
    //   console.log(`we have error`, this.props.data.portfolio.title)
    //   console.log(`rest`, this.props.data.portfolio)
    //   console.log('')
    //   console.log('')
    // }

    return (
      <div>
        {this.props.data.portfolio.acf.show_header_spacer && <HeaderSpacer />}
        <Grid>
          {this.props.data.portfolio.acf.show_featured_image &&
            this.props.data.portfolio.featured_media && (
              // <div
              //   style={{
              //     margin: '0 12px 24px',
              //     flexGrow: 1,
              //     flexShrink: 1,
              //     flexBasis: `${18 * 100}px`,
              //   }}
              // >
              <GridItem size="2x2">
                <Image
                  backgroundColor={
                    this.props.data.portfolio.featured_media.localFile
                      .childImageSharp.bgColor
                  }
                  sizes={
                    this.props.data.portfolio.featured_media.localFile
                      .childImageSharp.res_100
                  }
                />
              </GridItem>
            )}

          {/* {this.renderItems()} */}
          {/* <div className={Styles.portfolioGrid}> */}
          {/* <div className={Styles['portfolioItem--1x2']}>1x2</div>
            <div className={Styles['portfolioItem--1x1']}>1x1</div>
            <div className={Styles['portfolioItem--1x1']}>1x1</div>
            <div className={Styles['portfolioItem--2x2']}>2x2</div> */}
          {this.props.data.portfolio.tiles.map(this.renderItem2)}
          {/* </div> */}
        </Grid>

        <Navigation
          type="portfolio"
          prev={this.props.data.prev}
          next={this.props.data.next}
        />
      </div>
    )
  }
}

export default PortfolioSingleComponent



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolioSingle.js